import React from "react";

export function complianceChipClass(chip) {
  switch (chip) {
    case "Compliant":
      return "border-emerald-300 bg-emerald-100 text-emerald-900 dark:border-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-100";
    case "Partially compliant":
      return "border-amber-300 bg-amber-100 text-amber-950 dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-100";
    case "Non-compliant":
      return "border-red-300 bg-red-100 text-red-900 dark:border-red-800 dark:bg-red-950/50 dark:text-red-100";
    case "Error":
      return "border-rose-300 bg-rose-100 text-rose-900 dark:border-rose-800 dark:bg-rose-950/50 dark:text-rose-100";
    case "Pending":
      return "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200";
    default:
      return "border-transparent bg-transparent text-slate-400";
  }
}

export function complianceChipLabel(chip, { skipped } = {}) {
  if (!chip && skipped) return "Skipped";
  if (chip === "Partially compliant") return "Partial";
  if (chip === "Non-compliant") return "Non-comp.";
  return chip || "—";
}

/** Short label when a Non-compliant first pass was raised by the fallback. */
export function fallbackDisagreementLabel(chip, fallbackAction) {
  if (chip !== "Non-compliant") return "";
  const match = String(fallbackAction || "").match(
    /Compliance:\s*(Compliant|Partially compliant|Non-compliant)/i
  );
  if (!match) return "";
  const verdict = match[1].toLowerCase();
  if (verdict.startsWith("partial")) return "Partial";
  if (verdict === "compliant") return "Compliant";
  return "";
}

export function fallbackExplanation(fallbackAction) {
  const blob = String(fallbackAction || "").trim();
  if (!blob) return "";
  const match = blob.match(/Explanation:\s*([\s\S]*?)(?:\nCitations:|$)/i);
  return (match ? match[1] : blob).trim();
}

export default function RfpComplianceChip({ chip, skipped = false, onClick, disabled }) {
  const showSkipped = Boolean(skipped) && !chip;
  const label = complianceChipLabel(chip, { skipped: showSkipped });
  return (
    <button
      type="button"
      data-testid="rfp-compliance-chip"
      disabled={disabled}
      title={showSkipped ? "Skipped — not a requirement" : chip ? chip : "Check this requirement"}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className={`max-w-[6.5rem] shrink-0 rounded-full border px-2 py-1 text-[11px] font-semibold leading-tight ${
        showSkipped
          ? "border-slate-300 bg-slate-50 text-slate-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-400"
          : complianceChipClass(chip)
      } disabled:opacity-60`}
    >
      {label}
    </button>
  );
}
